import { MouseEvent, ReactElement } from 'react';
import { SocialIcon } from 'react-social-icons';
import { useTranslation } from 'react-i18next';

// Hooks.
import { useTrackEvent } from 'hooks';

// Images.
import comptiaFooterLogo from 'images/comptia-logo.png';

// Styles.
import styles from './Footer.module.scss';

export const Footer = (): ReactElement => {
  const { t } = useTranslation();
  const trackEvent = useTrackEvent('Footer');

  const handleLinkClick = (e: MouseEvent<HTMLAnchorElement>) => {
    const link = e.target as HTMLAnchorElement;
    trackEvent('Clicked', { label: link.innerText });
  };

  const handleSocialClick = (network: string) => () => {
    trackEvent('Clicked', { label: network });
  };

  return (
    <footer className={styles.footer}>
      Copyright &copy; CompTIA, Inc. All Rights Reserved.
    </footer>
  );
};
